
<template>
  <v-container>
    <!-- i am profile -> fazer o map state properly -->
    <v-card style="border-radius:12px" class="pr-9">
      <v-card-title primary-title>
        <div class="headline mb-0">Perfil</div>
      </v-card-title>
      <v-card-text class="px-9">
        <v-text-field v-model="profile.name" prepend-icon="mdi-account" label="Nome"></v-text-field>
        <v-text-field v-model="profile.email" prepend-icon="mdi-email" label="Email" readonly append-icon="mdi-lock mdi-18px"></v-text-field>
        <v-text-field v-model="profile.cpf" prepend-icon="mdi-account-card-details" label="CPF" v-mask="mask_cpf"></v-text-field>
        <!-- <v-text-field :value="profile.role_name_pt" prepend-icon="mdi-account-badge" label="Cargo" readonly append-icon="mdi-lock mdi-18px"></v-text-field> -->
        <!-- <v-text-field :value="text_data" prepend-icon="mdi-search" label="Salário" readonly></v-text-field> -->
      </v-card-text>
      <v-card-actions class="justify-end" v-if="true">
        <v-btn text color="primary" @click="dialog_password = true" rounded><v-icon left>mdi-lock-reset</v-icon>alterar senha</v-btn>
        <v-btn fab text color="success" @click="submitProfile()"><v-icon>mdi-content-save</v-icon></v-btn>
      </v-card-actions>
    </v-card>

    <v-dialog v-model="dialog_password" :overlay="false" max-width="500px" transition="dialog-transition" >
      <v-card style="border-radius:12px">
        <v-card-title primary-title>
          <div class="headline mb-0">Alteração de Senha</div>
        </v-card-title>
        <v-card-text>
          <v-form ref="formPassword" v-model="valid_password" lazy-validation>
            <v-text-field label="Senha Atual" v-model="profile.current_password" :rules="[rules.required]"
              :append-icon="show_current_password ? 'mdi-eye' : 'mdi-eye-off'" type="password"></v-text-field>
            <v-text-field label="Nova senha" v-model="profile.password" :rules="[rules.required, rules.min, rules.special_char, rules.number, rules.min]"
              :append-icon="show_password ? 'mdi-eye' : 'mdi-eye-off'" :type="show_password ? 'text' : 'password'" @click:append="show_password = !show_password"
            ></v-text-field>
            <v-text-field label="Confirme a nova senha" v-model="profile.password_confirmation" :rules="[rules.confirmation, rules.required, rules.min]"
              :append-icon="show_password2 ? 'mdi-eye' : 'mdi-eye-off'" :type="show_password2 ? 'text' : 'password'" @click:append="show_password2 = !show_password2"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn flat text color="error" @click="dialog_password = false">Cancelar</v-btn>
          <v-btn flat text color="success" @click="submitPassword()">Trocar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import { mask } from 'vue-the-mask'

export default {
  components: {
    // UserCard: ()=>import('../components/profile/UserProfile'),
  },
  directives: {
    mask,
  },
  data() {
    return {
      key: null,
      dialog_password: false,
      mask_cpf: '###.###.###-##',
      // profile:{},

      rules: {
        required: v => !!v || 'Campo é necessário.',
        email: v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail deve ser válido',
        special_char: v =>  /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(v) || "Deve conter caracter especial",
        number: v =>  /\d/.test(v) || 'Deve conter ao menos um número',
        min: v => !!v && v.length >= 9 || 'Min 9 caracteres',
        confirmation: v => this.checkPasswords(v) || 'Senhas devem ser iguais',
        cpf: v => (v && v.length == 14) || 'CPF deve ser completo',
      },
      show_password: false,
      show_password2: false,
      valid_password: true,
    }
  },
  methods: {
    checkPasswords(second) {
      return this.profile.password === second
    },
    submitProfile(){
      // if (this.$refs.formPassword.validate()){
        let {name, cpf, id} = this.profile
        let obj = {name, cpf, id}
        this.update(obj)
      // }
    },
    submitPassword(){
      if (this.$refs.formPassword.validate()){
        let {password, password_confirmation, id} = this.profile
        let obj = {password, password_confirmation, id}
        this.update(obj)
      }
    },
    ...mapActions({
      update: 'User/update',
      setProfile: 'User/setProfile',
    })
  },
  computed: {
    name() {
      return null
    },
    ...mapState({
      profile: state=> state.User.oneUser,

      updateUserWasGood: state=>state.User.updateUserWasGood,
      updateUserMessage: state=>state.User.updateUserMessage,
    })
  },
  watch: {
    dialog_password(nv,ov) {
      if (nv){
        } else if (nv == false){
          this.profile.password = null
          this.profile.password_confirmation = null
      }
    },
    updateUserWasGood(nv,ov) {
      // this.loading = false
      // this.loadingText= null
      if (nv){
        this.dialogEdit = false
        this.$swal({
          toast: true,
          position: 'top-end',
          timer: 3000,
          title: this.updateUserMessage? this.updateUserMessage :"Atualizado com sucesso",
          type: "success",
          showConfirmButton: false,
        })
        this.dialog_password = false
        this.fetchProfile()
      } else if (nv == false){
        this.$swal({
          toast: true,
          position: 'top-end',
          timer: 6000,
          title: "Houve um erro. "+this.updateUserMessage,
          type: "error",
          showConfirmButton: false,
        })
      }
    }
  },
}
</script>

<style scoped>

</style>